<template>
    <div v-on-click-outside="handleClickOutside" class="ui-popover">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';
import { vOnClickOutside } from '@vueuse/components';

const emit = defineEmits<{
    (event: 'opened'): void;
    (event: 'closed'): void;
    (event: 'click-outside', $event: MouseEvent): void;
}>();

onMounted(() => {
    emit('opened');
});

onBeforeUnmount(() => {
    emit('closed');
});

const handleClickOutside = ($event: MouseEvent) => {
    emit('click-outside', $event);
};
</script>
